import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { CREATE_MECHANIC, UPDATE_MECHANIC } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_MECHANIC, GET_SKILL_LIST } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/mechanics-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState({})
  const [mechanic, setMechanic] = useState()

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: id === 'salary' ? parseFloat(value) : value,
    })
  }

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {/* {detailType(props.match.params, onChangeHandler)} */}
      <Query
        query={GET_SKILL_LIST}
        variables={{ id: props.match.params.id }}
        fetchPolicy='cache-and-network'
      >{({
        data, error, loading,
      }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            {
              isAddMode
                ? detailType(props.match.params, onChangeHandler, data.RepairSkillList.lists)
                : <Query
                  query={GET_MECHANIC}
                  variables={{ id: props.match.params.id }}
                  fetchPolicy='cache-and-network'
                >{({
                  data: mechdata, error: mecherror, loading: loadingerror,
                }) => {
                  if (loadingerror && _.isEmpty(mechdata)) return <Loading center='true' />
                  if (mecherror) return <P>เกิดข้อผิดพลาด</P>
                  if (!_.isEmpty(data)) setMechanic(mechdata.MechanicInfo)
                  onChangeHandler = (id, value) => {
                    setMutationVariables({
                      firstname: mechdata.MechanicInfo.firstname,
                      department: mechdata.MechanicInfo.department,
                      nationalId: mechdata.MechanicInfo.nationalId,
                      phoneNumber: mechdata.MechanicInfo.phoneNumber,
                      companyType: mechdata.MechanicInfo.companyType,
                      skills: _.map(mechdata.MechanicInfo.skills, v => v.id),
                      ...mutationVariables,
                      [id]: id === 'salary' ? parseFloat(value) : value,
                    })
                  }
                  return (
                    <Div>
                      {
                        detailType(props.match.params, onChangeHandler, data.RepairSkillList.lists, mechdata.MechanicInfo) // argument mode
                      }
                    </Div>
                  )
                }}
                </Query>
            }
          </Div>
        )
      }}
      </Query>
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_MECHANIC : UPDATE_MECHANIC}
            >{(doAction, resp) => (
              <ActionBar
                loading={resp.loading}
                disabled={_.isUndefined(mutationVariables.firstname) || _.isEmpty(mutationVariables.firstname)
                  || _.isUndefined(mutationVariables.department) || _.isEmpty(mutationVariables.department)
                  || _.isUndefined(mutationVariables.companyType)
                  || _.isUndefined(mutationVariables.phoneNumber) || _.isEmpty(mutationVariables.phoneNumber)
                  || _.isUndefined(mutationVariables.skills) || _.isEmpty(mutationVariables.skills)}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={{ ...mutationVariables }}
                props={props}
                mechanic={mechanic}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
              mechanic={mechanic}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
